export enum AlarmNotificationEndingReasonEnum {
    None,
    Clear,
    Website,
    Email,
    Voice,
    Acknowledged,
    SetpointDeleted,
    Text,
    Mobile,
    Mobile_iOS,
    MobileHTML5
}
